export const tagGroups = [
  {
    group: 'Nature',
    tags: [
      'beauty in nature',
      'scenics - nature',
      'horizon over water',
      'environment',
      'landscape',
      'sunset',
      'dusk',
      'evening',
      'natural environment',
      'dramatic sky',
      'nature',
      'horizon',
      'power in nature',
      'dawn',
      'romantic sky',
      'sunrise',
    ],
  },
  {
    group: 'Family',
    tags: [
      'family',
      'small group of people',
      'family reunion',
      'child',
      'parent',
      'pet',
      'amusement ride',
      'park',
    ],
  },
  {
    group: 'Friends',
    tags: [
      'friendship',
      'cheerful',
      'fun',
      'party',
      'driving',
      'road trip',
      'amusement ride',
    ],
  },
  {
    group: 'Remote Locations',
    tags: [
      'idyllic',
      'non-urban scene',
      'rural scene',
      'town',
      'remote',
      'suburban',
    ],
  },
  {
    group: 'Beach & Islands ',
    tags: [
      'sea',
      'ocean',
      'coast',
      'palm tree',
      'beach',
      'island',
      'shore',
      'bay',
      'seaplane',
      'bay of water',
      'beach hut',
      'boardwalk',
    ],
  },
  {
    group: 'Mountains & Hike',
    tags: [
      'mountain',
      'mountain range',
      'waterfall',
      'cliff',
      'canyon',
      'snowcapped mountain',
      'mountain peak',
      'summit',
      'mountaineering',
      'hiking',
      'trail',
      'mountain pass',
      'mountain climbing',
    ],
  },
  {
    group: 'Deserts',
    tags: [
      'desert',
      'sand dune',
      'arabian camel',
      'dune',
      // "sand", // TODO @bali (sand is same as beaches)
      'arid climate',
      'canyon',
      // "tundra", // TODO @bali
      'rock hoodoo',
      // "plateau" // TODO @bali (alps)
    ],
  },
  {
    group: 'Scuba & Sealife  ',
    tags: [
      'reef',
      'coral reef',
      'marine mammal',
      'dolphin',
      'common bottlenose dolphin',
      'marine biology',
      'marine',
      'sea life',
      'goldfish',
      'koi carp',
      'koi',
      'undersea',
      'humpback whale',
      'seaplane',
      'school of fish',
      'great white shark',
      'killer whale',
      'grey whale',
      'beluga whale',
      'shark',
      'school of fish',
      'fish',
      'coral',
    ],
  },
  {
    group: 'Wildlife & Safari',
    tags: [
      'prairie',
      'savanna',
      'steppe',
      'grassland',
      'animal themes',
      'animal wildlife',
      'group of animals',
      'domestic animals',
      'large group of animals',
      'bird',
      'marine mammal',
      'dolphin',
      'common bottlenose dolphin',
      'elephant',
      'indian elephant',
      'african elephant',
      'leopard',
      'cheetah',
      'horse',
      'cattle',
      'marine biology',
      'marine',
      'sea life',
      'goldfish',
      'koi carp',
      'koi',
      'arabian camel',
      'safari',
      'humpback whale',
      'polar bear',
      'snow leopard',
      'great white shark',
      'killer whale',
      'grey whale',
      'beluga whale',
      'shark',
      'school of fish',
      'fish',
      'deer',
      'reindeer',
      'gazelle',
      'american bison',
      'bald eagle',
      'polar bear',
      'eagle',
      'llama',
      'parakeet',
      'red fox',
      'lynx',
      'alpaca',
      'alligator',
      'puma',
      'wild cat',
      'wolf',
      'bobcat',
      'rhinoceros',
      'brown bear',
      'great ape',
      'hippopotamus',
      'lion cub',
      'panda',
      'hyena',
      'kangaroo',
      'bison',
      'gorilla',
      'ostrich',
      'elk',
      'baboon',
      'elephant calf',
      'orangutan',
      'moose',
      'toucan',
      'capuchin monkey',
      'snow leopard',
      'cougar',
      'meerkat',
    ],
  },
  {
    group: 'Urban & City Travel',
    tags: [
      'city',
      'residential district',
      'cityscape',
      'urban area',
      'urban skyline',
      'skyscraper',
      'metropolitan area',
      'town square',
      'tourist',
      'tourism',
      'infrastructure',
      'metropolis',
      'city life',
    ],
  },
  {
    group: 'Hotels & Stays',
    tags: [
      'room',
      'home interior',
      'home showcase interior',
      'bed',
      'bedroom',
      'bathroom',
      'domestic bathroom',
      'hotel',
      'luxury hotel',
      'villa',
      'hotel room',
      'suite residential area',
      'mansion',
      'swimming pool',
      'tourist resort',
      'resort',
      'poolside',
      'infinity pool',
      'deck',
      'patio',
      'jacuzzi',
      'spa',
      'health spa',
      'hot tub',
      'hotel suite',
      'condominium',
      'holiday villa',
      'ski resort',
      'resort town',
      'beach hut',
      'double bed',
      'hotel suite',
      'chalet',
    ],
  },
  {
    group: 'Adventure & Activities',
    tags: [
      'swimming pool',
      'tourist resort',
      'poolside',
      'infinity pool',
      'high angle view',
      'swimming',
      'nautical vessel',
      'boating',
      'boat',
      'ship',
      'yacht',
      'air vehicle',
      'airplane',
      'golf course',
      'green - golf course',
      'golf',
      'golf club',
      'golf swing',
      'golf cart',
      'sports',
      'hiking',
      'safari',
      'skiing',
      'winter sports',
      'surfing',
      'cycling',
      'water sports',
      'snorkeling',
      'scuba diving',
      'hot air ballooning',
      'whitewater kayaking',
      'horseback riding',
      'extreme sports',
      'surfing equipment',
      'sports equipment',
      'camping',
      'jacuzzi',
      'spa',
      'health spa',
      'hot tub',
      'adventure',
      'activity',
      'exercise',
      'physical fitness',
      'yoga',
      'sports car',
      'sport utility vehicle',
      'bicycle',
      'motorcycle',
      'bowling',
      'barbecue',
      'picnic',
      'ranch',
      'banquet',
      'performance art',
      'aurora polaris',
      'aurora',
      'shopping mall',
      'suspension bridge',
      'seaplane',
      'weekend activities',
      'endurance sports',
      'ski',
      'ski holiday',
      'bonfire',
      'yoga class',
      'cycle sport',
      'mountain bike',
      'climbing',
      'snowboarding',
      'windsports',
      'windsurfing',
      'rowing',
      'sailing ship',
      'yachting',
      'paddleboarding',
      'parasailing',
      'sled dog racing',
      'dog sled',
      'cross-country skiing',
      'outdoor exercise',
      'equestrian sport',
      'skateboarding',
      'underwater diving',
      'mountain climbing',
      'extreme terrain',
      'rock climbing',
      'off-roading',
      'driving',
      'road trip',
      'tent',
      'tree canopy',
      'minivan',
      'van',
      'campfire',
    ],
  },
  {
    group: 'Relaxation and Leisure',
    tags: [
      'tranquility',
      'relaxation',
      'tranquil scene',
      'wellbeing',
      'summer',
      'clear sky',
      'resort',
      'poolside',
      'infinity pool',
      'deck',
      'patio',
      'jacuzzi',
      'spa',
      'health spa',
      'hot tub',
      'leisure activity',
      'zen-like',
      'art',
    ],
  },
  {
    group: 'Foodie Spots',
    tags: [
      'food and drink',
      'food',
      'drink',
      'healthy eating',
      'breakfast',
      'vegetable',
      'fruit',
      'meat',
      'seafood',
      'dessert',
      'sweet food',
      'salad',
      'pasta',
      'chocolate',
      'cake',
      'strawberry',
      'egg',
      'fried egg',
      'coffee',
      'hot drink',
      'juice',
      'orange juice',
      'wine',
      'red wine',
      'white wine',
      'wine glass',
      'cocktail',
      'alcoholic beverage',
      'martini',
      'piña colada',
      'milk',
      'cream',
      'cheese',
      'wine bottle',
      'brunch',
      'tavern',
      'cafe',
      'eating',
      'cuisine',
      'food and drink industry',
      'snack',
      'asian food',
      'chinese food',
      'japanese food',
      'sushi',
      'kobe beef',
      'steak',
      'frothy drink',
      'wok',
      'vegetarian food',
      'mexican food',
      'thai food',
      'bartender',
      'yakiniku',
      'carbonara',
      'pasta pomodoro',
      'clam chowder',
      'indian cuisine',
      'paella',
      'dim sum',
      'café',
      'winery',
      'bar',
      'bar counter',
    ],
  },
  {
    group: 'History & Culture',
    tags: [
      'history',
      'the past',
      'ancient',
      'ancient history',
      'ancient civilization',
      'old ruin',
      'ruins',
      'archaeology',
      'landmark',
      'fresco',
      'pagoda',
      'religion',
      'spirituality',
      'culture',
      'historic site',
      'archaeological site',
      'castle',
      'château',
      'fort',
      'museum',
      'medieval architecture',
      'monument',
      'water castle',
      'arts culture and entertainment',
      'performing arts',
      'performing arts event',
      'culture',
      'art gallery',
      'music festival',
      'literature',
      'market',
      'bazaar',
    ],
  },
  {
    group: 'Romantic Retreats',
    tags: [
      'love',
      'romance',
      'happiness',
      'emotion',
      'togetherness',
      'bonding',
      'nightlife',
      'music',
      'musician',
      'string instrument',
      'guitar',
      'piano',
      'sunset',
      'sea',
      'ocean',
      'coast',
      'palm tree',
      'beach',
      'island',
      'two people',
      'romantic sky',
    ],
  },
  {
    group: 'Party',
    tags: [
      'popular music concert',
      'festival',
      'celebration',
      'cheerful',
      'fun',
      'party',
      'festival goer',
      'clubbing',
      'block party',
      'pool party',
      'party favor',
      'music festival',
      'wine',
      'red wine',
      'white wine',
      'wine glass',
      'cocktail',
      'alcoholic beverage',
      'martini',
      'wine bottle',
      'tavern',
      'bartender',
      'bar',
      'bar counter',
    ],
  },
  {
    group: 'Forests & Wilderness',
    tags: [
      'forest',
      'rainforest',
      'jungle',
      'wilderness',
      'coniferous tree',
      'pine tree',
      'pinaceae',
      'foliage',
      'fern',
      'tropical rainforest',
      'pine',
      'tree canopy',
      'suspension bridge',
      'bonfire',
      'tree house',
      'pine',
      'american bison',
      'bald eagle',
      'elk',
      'moose',
      'trail',
      'mountain pass',
      'mountain climbing',
      'waterfall',
      'pond',
      'river',
      'reservoir',
      'lake',
      'waterfront',
      'creek',
      'ravine',
      'dam',
      'freshwater aquarium',
      'lake district',
      'water\'s edge',
      'tent',
      'camping',
      'campfire',
    ],
  },
  {
    group: 'Rivers and Lakes',
    tags: [
      'pond',
      'river',
      'reservoir',
      'lake',
      'waterfront',
      'creek',
      'ravine',
      'dam',
      'freshwater aquarium',
      'lake district',
      'water\'s edge',
      'waterfall',
      'whitewater kayaking',
      'marsh',
      'wetland',
    ],
  },
  {
    group: 'Seasonal',
    tags: [
      'ice',
      'snow',
      'frozen',
      'glacial landform',
      'tundra',
      'iceberg',
      'aurora polaris',
      'aurora',
      'ice cap',
      'sea ice',
      'polar climate',
      'snowing',
      'ski holiday',
      'fireplace',
      'hearth',
      'chalet',
      'dog sled',
      'sled dog racing',
      'reindeer',
      'king penguin',
      'polar bear',
      'snow leopard',
      'ski holiday',
      'skiing',
      'snowboarding',
      'ski mountaineering',
      'nordic skiing',
      'ski lift',
      'ski resort',
      'winter',
      'autumn',
      'tropical climate',
      'sunlight',
      'beach',
      'sun',
      'summer',
      'rain',
      'extreme weather',
      'thunderstorm',
      'rainy season',
      'spring',
      'floristry',
      'blossom',
      'springtime',
      'park',
      'king penguin',
      'polar bear',
      'snow leopard',
      'ski holiday',
      'skiing',
      'snowboarding',
      'ski mountaineering',
      'nordic skiing',
      'ski lift',
      'ski resort',
      'winter',
      'autumn',
      'tropical climate',
      'sunlight',
      'beach',
      'sun',
      'summer',
      'rain',
      'extreme weather',
      'thunderstorm',
      'rainy season',
      'spring',
      'floristry',
      'blossom',
      'springtime',
      'park',
    ],
  },
  {
    group: 'Architecture',
    tags: [
      'bridge',
      'architectural site',
      'viaduct',
      'architecture',
      'castle',
      'château',
      'fort',
      'public library',
      'medieval architecture',
      'neo-classical',
      'estate',
      'medieval architecture',
      'gothic style',
      'victorian style',
      'baroque style',
      'brutalist architecture',
      'architecture and art',
    ],
  },
  {
    group: 'Holiday Retreats',
    tags: [
      'vacation',
      'holiday',
      'trip',
      'tourism',
      'journey',
      'tourist',
      'tourism',
      'resort town',
      'tourist resort',
      'ski resort',
      'beach',
      'island',
      'resort',
      'ski holiday',
      'holiday villa',
    ],
  },
];
